import { useMemo } from "react";
import { AuditDataModel, IMissingTitle } from "../types";
import { criticalListLeft, warningListLeft, noticesListLeft, passedListLeft } from "../constants";

export const useSeoAuditData = (collectionData: AuditDataModel | null) => {
  const countIssues = (list: { name: string; value: number }[]) =>
    list.map((x) => ({
      name: x.name,
      value: collectionData?.missingTitles.filter((a) => a.issues.includes(x.name)).length || 0,
    }));

  const calculatePercentage = (list: { name: string; value: number }[], collected: { name: string; value: number }[]) => {
    const filtered = collected.filter((issue) => issue.value > 0);
    return ((filtered.length / list.length) * 100).toFixed(2);
  };

  const criticalCollected = useMemo(() => countIssues(criticalListLeft), [collectionData]);
  const warningCollected = useMemo(() => countIssues(warningListLeft), [collectionData]);
  const noticesCollected = useMemo(() => countIssues(noticesListLeft), [collectionData]);
  const passedCollected = useMemo(() => countIssues(passedListLeft), [collectionData]);

  return {
    criticalCollected,
    warningCollected,
    noticesCollected,
    passedCollected,
    criticalPercentage: calculatePercentage(criticalListLeft, criticalCollected),
    warningPercentage: calculatePercentage(warningListLeft, warningCollected),
    noticesPercentage: calculatePercentage(noticesListLeft, noticesCollected),
    passedPercentage: calculatePercentage(passedListLeft, passedCollected),
    checkSafe: () => collectionData?.missingTitles.some((a) => a.issues.includes("Google Safe Browsing")) ? "Site is safe" : "Site is not safe",
  };
};